import { pricingPlans } from '@/mocks/pricing';

export default function Pricing() {
  return (
    <section id="pricing" className="py-24 md:py-32 bg-surface">
      <div className="w-full px-6 md:px-10 lg:px-16">
        {/* Header */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16 md:mb-20">
          <div className="max-w-lg">
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-accent-light text-accent text-xs font-semibold tracking-wider uppercase mb-6">
              <i className="ri-wallet-3-line" />
              Simple Pricing
            </span>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-dark leading-[1.1] tracking-tight">
              Choose Your
              <br />
              Creative Plan
            </h2>
          </div>
          <p className="text-dark-muted text-base md:text-lg max-w-md leading-relaxed">
            Start free — 20 credits, no card required. Upgrade any time for more credits and Pro features. Cancel anytime, no hidden fees.
          </p>
        </div>

        {/* Pricing Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-8 max-w-6xl mx-auto">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`relative rounded-2xl p-8 md:p-10 transition-all duration-300 ${
                plan.highlighted
                  ? 'bg-dark text-white shadow-2xl shadow-primary/10 border-2 border-primary/20'
                  : 'bg-white text-dark border border-surface-dark/50 hover:shadow-xl hover:shadow-primary/5 hover:border-primary/10'
              }`}
            >
              {plan.highlighted && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1.5 bg-primary text-white text-xs font-bold rounded-full">
                  Most Popular
                </span>
              )}

              {/* Plan Name */}
              <h3 className="font-display text-lg font-bold mb-1">{plan.name}</h3>
              <p className={`text-sm mb-8 ${plan.highlighted ? 'text-white/50' : 'text-dark-muted'}`}>
                {plan.description}
              </p>

              {/* Price */}
              <div className="mb-2">
                <span className="text-4xl md:text-5xl font-display font-bold">
                  ${plan.price}
                </span>
                <span className={`text-sm ml-1 ${plan.highlighted ? 'text-white/50' : 'text-dark-muted'}`}>
                  /{plan.period}
                </span>
              </div>

              {/* Billing note */}
              <p className={`text-xs font-medium mb-8 ${plan.highlighted ? 'text-primary' : 'text-primary'}`}>
                <i className="ri-refresh-line mr-1" />Billed monthly · cancel anytime
              </p>

              {/* Features */}
              <ul className="space-y-3.5 mb-8">
                {plan.features.map((feature, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <i className={`ri-check-line mt-0.5 ${plan.highlighted ? 'text-primary' : 'text-accent'}`} />
                    <span className={`text-sm leading-relaxed ${plan.highlighted ? 'text-white/75' : 'text-dark-muted'}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              {/* CTA — freemium front door. Every plan's button sends the
                  visitor to free sign-up (no card, 20 credits); they upgrade
                  to this tier from inside the app. No trial — paid plans are
                  charged day-one once the user chooses to upgrade. */}
              <a
                href="/auth/sign-up"
                className="block text-center py-3.5 rounded-full text-sm font-bold transition-all bg-primary hover:bg-primary-hover text-white shadow-lg shadow-primary/20"
              >
                {plan.cta}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}